import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=aee82f94&scoped=true"
import script from "./lunbo.vue?vue&type=script&lang=js"
export * from "./lunbo.vue?vue&type=script&lang=js"
import style0 from "./lunbo.vue?vue&type=style&index=0&id=aee82f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee82f94",
  null
  
)

export default component.exports